<template>
  <div class="body-bottom-view">
    <img src="@/assets/backoff.png" alt="" @click="goPage">
    <img src="@/assets/forward.png" alt="">
  </div>
</template>

<script>
export default {
  data(){
    return{
      btnText01: '<',
      btnText02: '>',
    }
  },
  props: {
    page: {
      prop: Object,
      default: () => '/'
    }
  },
  methods: {
    goPage(){
      this.$router.replace(this.page, () => {
        window.location.reload()
      })
    }
  }
}
</script>


<style scoped lang="scss">
  .body-bottom-view{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    height: 8vh;
    position: fixed;
    bottom: 0;

    img{ width: 5vw; }
    img:nth-child(1){
      margin-left: 30vw;
      margin-top: 0.5vh;
    }
    img:nth-child(2){
      margin-right: 30vw;
      margin-top: 0.5vh;
    }
  }
</style>